import Config from '@config';
import { ReferenceBook } from '@gasbi/shared';

import { injectSupplySlice } from '@/app/supplyApi';
import { FiltersGrid, Pagination } from '@/features/types';
import {
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@/features/utils';

const api = injectSupplySlice({
  baseUrl: `${Config.VITE_API_URL}/departments`,
  tagTypes: ['Department'],
  endpoints: builder => ({
    getDepartments: builder.query<ReferenceBook[], void>({
      query: () => ({ url: '', method: 'GET' }),
      providesTags: () => ['Department'],
    }),
    getDepartmentsI: builder.infiniteQuery<
      ReferenceBook[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/query',
        method: 'GET',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['Department'],
    }),
    getDepartmentById: builder.query<ReferenceBook, string>({
      query: id => ({ url: `/${id}`, method: 'GET' }),
      providesTags: (_result, _error, id) => [{ type: 'Department', id }],
    }),
    createDepartment: builder.mutation<string, Pick<ReferenceBook, 'value'>>({
      query: data => ({ url: '', method: 'POST', data }),
      invalidatesTags: ['Department'],
    }),
    updateDepartment: builder.mutation<
      void,
      { id: string; data: Omit<ReferenceBook, 'id'> }
    >({
      query: ({ id, data }) => ({ url: `/${id}`, method: 'PUT', data }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: 'Department', id },
        'Department',
      ],
    }),
  }),
});

export const departmentsApi = api;

export const {
  useGetDepartmentsQuery,
  useGetDepartmentByIdQuery,
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation,
} = api;

export const useGetDepartmentsInfiniteQuery = normalizeInfiniteQueryData(
  api.useGetDepartmentsIInfiniteQuery,
);
